import type React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useThemeColors } from "../hooks/UseThemeColors";

interface PaginationControlsProps {
  currentPage: number;
  totalPages: number;
  onPrevious: () => void;
  onNext: () => void;
}

const PaginationControls: React.FC<PaginationControlsProps> = ({
  currentPage,
  totalPages,
  onPrevious,
  onNext,
}) => {
  const { primaryColor, darkText } = useThemeColors();

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 3, gap: 2 }}>
      <Button
        variant="outlined"
        onClick={onPrevious}
        disabled={currentPage === 1}
        sx={{
          textTransform: "none",
          borderColor: primaryColor,
          color: primaryColor,
        }}
      >
        Previous
      </Button>
      <Typography sx={{ alignSelf: "center", color: darkText }}>
        Page {currentPage} of {totalPages}
      </Typography>
      <Button
        variant="outlined"
        onClick={onNext}
        disabled={currentPage >= totalPages}
        sx={{
          textTransform: "none",
          borderColor: primaryColor,
          color: primaryColor,
        }}
      >
        Next
      </Button>
    </Box>
  );
};

export default PaginationControls;
